// FT-143: чипсы активных фильтров страницы клиентов и снятие фильтра по ключу.
// Чистые функции по образцу carsFilterChips.js: перевод и резолвер филиала
// приходят параметрами, DOM и Vue здесь не участвуют — юнит-тестируемо.

// Порядок ключей = порядок чипсов на экране.
export const CHIP_KEYS = ["entity", "debtor", "category", "source", "company_id", "birthday_today"];

// Канонические значения категории (кириллица БД) → ключи локализации.
const CATEGORY_KEYS = {
  "Новый": "customer_category.new",
  "Лояльный": "customer_category.loyal",
  "Постоянный": "customer_category.statement",
  "Серый": "customer_category.problem",
  "Чёрный": "customer_category.bad",
};

export function categoryText(t, value) {
  return CATEGORY_KEYS[value] ? t(CATEGORY_KEYS[value]) : String(value);
}

// filters — текущее состояние фильтров; t — функция перевода ($t);
// branchText — резолвер company_id → человекочитаемый филиал (branchCity страницы).
export function activeFilterChips(filters, { t, branchText } = {}) {
  const f = filters || {};
  const chips = [];

  if (f.entity === true) {
    chips.push({ key: "entity", label: t("clients_list.type"), text: t("clients_list.entities") });
  } else if (f.entity === false) {
    chips.push({ key: "entity", label: t("clients_list.type"), text: t("clients_list.persons") });
  }
  if (f.debtor === true) {
    chips.push({ key: "debtor", label: t("custom.debts_clients"), text: t("custom.yes") });
  } else if (f.debtor === false) {
    chips.push({ key: "debtor", label: t("custom.debts_clients"), text: t("custom.no") });
  }
  if (f.category && f.category.length) {
    chips.push({
      key: "category",
      label: t("clients.category"),
      text: f.category.map((c) => categoryText(t, c)).join(", "),
    });
  }
  if (f.source && f.source.length) {
    chips.push({ key: "source", label: t("custom.source"), text: f.source.join(", ") });
  }
  if (f.company_id) {
    chips.push({
      key: "company_id",
      label: t("custom.branch"),
      text: branchText ? String(branchText(f.company_id)) : String(f.company_id),
    });
  }
  if (f.birthday_today === true) {
    chips.push({ key: "birthday_today", label: t("clients_list.birthday_today"), text: t("custom.yes") });
  }

  return chips;
}

// Снятие одного фильтра. Пустое значение у каждого ключа своё: список — [],
// tri-state — null, тумблер ДР — false (null в v-checkbox читается как
// «не определено» и оставляет галку в чужом состоянии).
export function withFilterCleared(filters, key) {
  const next = { ...(filters || {}) };
  if (key === "category") next.category = [];
  else if (key === "source") next.source = [];
  else if (key === "birthday_today") next.birthday_today = false;
  else next[key] = null;
  return next;
}

// Дефолтное (пустое) состояние фильтров — единая точка для страницы, панели и пресетов.
export function emptyFilters() {
  return {
    search: null,
    entity: null,
    debtor: null,
    category: [],
    source: [],
    company_id: null,
    birthday_today: false,
  };
}
